import { render, staticRenderFns } from "./DictionaryManage.vue?vue&type=template&id=052e1e60&scoped=true"
import script from "./DictionaryManage.vue?vue&type=script&lang=js"
export * from "./DictionaryManage.vue?vue&type=script&lang=js"
import style0 from "./DictionaryManage.vue?vue&type=style&index=0&id=052e1e60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052e1e60",
  null
  
)

export default component.exports